module.exports = __webpack_public_path__ + "static/media/leavecalculation.cea63968.svg";